import { sizeProp } from "../../propTypes";

export const LockCircleIcon = ({ size = 24 }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_4418_8318)">
                <path d="M12 7.75C10.11 7.75 9.75 8.54 9.75 10V10.62H14.25V10C14.25 8.54 13.89 7.75 12 7.75Z" fill="white" style={{ fill: "var(--fillg)" }}/>
                <path d="M11.9999 15.1004C12.6074 15.1004 13.0999 14.6079 13.0999 14.0004C13.0999 13.3929 12.6074 12.9004 11.9999 12.9004C11.3924 12.9004 10.8999 13.3929 10.8999 14.0004C10.8999 14.6079 11.3924 15.1004 11.9999 15.1004Z" fill="white" style={{ fill: "var(--fillg)" }}/>
                <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM17.38 14.5C17.38 16.7 16.7 17.38 14.5 17.38H9.5C7.3 17.38 6.62 16.7 6.62 14.5V13.5C6.62 11.79 7.03 11 8.25 10.73V10C8.25 9.07 8.25 6.25 12 6.25C15.75 6.25 15.75 9.07 15.75 10V10.73C16.97 11 17.38 11.79 17.38 13.5V14.5Z" fill="white" style={{ fill: "var(--fillg)" }}/>
            </g>
            <defs>
                <clipPath id="clip0_4418_8318">
                    <rect width="24" height="24" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    );
};

LockCircleIcon.propTypes = sizeProp